









































import { Component, Mixins } from 'vue-mixin-decorator';
import { SlotMixin } from '@/mixins/SlotMixin';
import {
  GET_INVOICE,
  GET_STATUS, INVOICE_REQUEST
} from '@/store/models/work/enterprise/invoices/outgoing';
import { Getter, namespace } from 'vuex-class';
import { Invoice, Product } from '@/types/work/invoice';
import InvoiceItem from '@/components/work/invoices/item.vue';
import { GET_PRODUCTS, PRODUCTS_REQUEST } from '@/store/models/work/enterprise/invoices/products';
import Photo from '@/components/Photo.vue';
import { CATEGORIES_REQUEST } from '@/store/models/work/enterprise/products/categories';
import { NAMESPACE as CR_NAMESPACE } from '@/store/models/work/enterprise/cashRegisters';
import { ITEMS_REQUEST } from '@/store';
import LogItem from '@/components/work/LogItem.vue';
import ProductItem from '@/components/work/invoices/product/ProductItem.vue';

const cRStore = namespace(CR_NAMESPACE);
@Component({
  components: { ProductItem, LogItem, Photo, InvoiceItem }
})
export default class ShowOutgoing extends Mixins<SlotMixin>(SlotMixin) {
  @Getter(GET_INVOICE) invoice!: Invoice;
  @Getter(GET_STATUS) status!:boolean|null;
  @Getter(GET_PRODUCTS) products!: Product;
  @cRStore.Action(ITEMS_REQUEST) cRRequest: any;

  get loading () {
    return this.status === null;
  }

  getInvoice () {
    this.$store.dispatch(INVOICE_REQUEST, this.$route.params.invoice);
    this.$store.dispatch(PRODUCTS_REQUEST, this.$route.params.invoice);
  }

  created () {
    this.getInvoice();
    this.$store.dispatch(PRODUCTS_REQUEST, this.$route.params.invoice);
    this.$store.dispatch(CATEGORIES_REQUEST, this.$route.params.enterprise);
    this.$gtag.event('page_view', {});
    this.cRRequest();
  }
}
